import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text, Button as BaseButton } from '@leroy-merlin-br/backyard-react-ui'

const imgStyles = ({ theme }) => css`
  label: product__image;

  border: 1px solid ${theme.colors.g400};
  border-radius: ${theme.borderRadius.giga};

  margin-right: ${theme.spacings.kilo};
`

const productTitleStyles = ({ theme }) => css`
  label: product__title;

  color: ${theme.colors.p500};

  width: 100%;
  display: flex;
`

const wrapperStyles = () => css`
  label: product__wrapper;

  width: 100%;
  display: flex;
`

const contentStyles = ({ theme }) => css`
  label: product__content;

  width: calc(100% - (82px - ${theme.spacings.kilo}));
`

const buttonStyles = ({ theme }) => css`
  label: product__button;

  height: 36px;

  svg {
    fill: ${theme.colors.p600};

    margin-right: ${theme.spacings.byte};
  }
`

export const Img = styled('img')(imgStyles)
export const ProductTitle = styled(Text)(productTitleStyles)
export const Content = styled('div')(contentStyles)
export const Wrapper = styled('div')(wrapperStyles)
export const Button = styled(BaseButton)(buttonStyles)
